import { styled } from '@mui/material';
import { GuideData } from '../types/types';

const FooterView = styled('div')(() => ({
  marginTop: '10px',
  fontSize: '13px',
  whiteSpace: 'pre'
}));

export default function FooterComponent({ guide }: { guide: GuideData }) {

  return (
    guide.footer && (
      <FooterView>
        {guide.footer.contents[0].html}
      </FooterView>
    )
  );
}
